module.exports = __webpack_public_path__ + "0499177a4802db0b762e0b8551d08ace.svg";